// Write your URL Builder Query here
// It is similar to the query in gatsby-node.js
// Here, we will export a function containing a string.
module.exports = function(locale, preview = false) {
  return `
 fragment PageMetaDataFragment on PageMetaData {
  sys {
  id
  }
  __typename
  pageTitle
  metaTitle
  metaDescription
  metaKeywords
  openGraphPageTitle
  openGraphDescription
 }
  
 {
  contentPageCollection(locale: "${locale}", preview: ${preview}) {
  items {
  sys {
  id
  publishedAt
  }
  slug
  breadcrumbTitle
  sitemapTitle
  parentPage {
  slug
  parentPage {
  slug
  parentPage {
  slug
  parentPage {
  slug
  parentPage {
  slug
  }
  }
  }
  }
  }
  }
  }
  
  sitemapCollection(locale: "${locale}", preview: ${preview})
  {
  items{
  sys{
  id
  }
  pageHeading
  slug 
  breadcrumbTitle
  pageMetadata {
  ... on PageMetaData {
  ...PageMetaDataFragment
  }
  }
  }
  }
  
  productCollection(locale: "${locale}", preview: ${preview}) {
  items {
  sys {
  id
  publishedAt
  }
  breadcrumbTitle
  sitemapTitle
  slug
  parentPage {
  slug
  }
  }
  }
  articleListCollection(locale: "${locale}", preview: ${preview}) {
  items {
    name
  sys {
  id
  publishedAt
  }
  facetCategory {
    uniqueId
  }
  facet{
    title
  }
  slug
  breadcrumbTitle
  sitemapTitle
  parentPage {
  slug
  }
  }
  }
  
  articleCollection(locale: "${locale}", preview: ${preview}, limit : 150) {
  items {
  sys {
  id
  publishedAt
  }
  title 
  slug 
  breadcrumbTitle
  sitemapTitle
  parentPage {
  ...on ArticleList{
  slug
  }
  ...on ContentPage{
  slug
  }
  }
  }
  }
  productListCollection(locale: "${locale}", preview: ${preview}) {
  items {
    name
  sys {
  id
  publishedAt
  }
  facetCategory {
    uniqueId
  }
  facet{
    title
  }
  slug
  breadcrumbTitle
  sitemapTitle
  parentPage {
  sys {
  id
  publishedAt
  }
  slug
  breadcrumbTitle
  sitemapTitle
  parentPage {
  slug
  }
  }
  }
  }
 } 
 `;
};
